export class requestParam {
    merchantId: string;
    transactionAmount: string;
    transactionCurrency: string;
    hashedString: string;
    appId: string;
    referenceNumber: string;
    lang: string;
    secure_hash: string;
    paymentType: string;
    showResult: string;
    secretKey: string;
}



    



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/requestparam.ts